export default __webpack_public_path__ + "images/Tex-Mex.19677f.jpg";